<mat-expansion-panel header-expanded-state-height="10">
    <mat-expansion-panel-header>
      <mat-panel-title> San Luis Potosí </mat-panel-title>
      <mat-panel-description>
        <div class="sanity-header">
           <div class="sanity-kpi"  *ngFor="let sanityIcon of sanityIcons">
                <span class="icon" [matTooltip]="sanityIcon.toolTip" [style.background-image]="'url(' + sanityIcon.icon + ')'"></span>
                <span class="status"></span>
           </div>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
     <!-- (cellClickEvent)="ContactosCellClick($event)" (addClickEvent)="ContactosAddClick($event)" (saveChangesEvent)="contactosSaveChanges($event)" [Filter]="gFilter" [GridSources]="contactosGridSource" -->
     <neoris-grid [ColumnsConfiguration]="columnsConfiguration" [GridTitle]="gridTitle"
            [Data]="gridData"
            [ShowChecks]="false"></neoris-grid>
  </mat-expansion-panel>